import {
  Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  EventEmitter,
} from '@angular/core';
import { ScrollerOptions } from 'primeng/api';
import { DropdownChangeEvent, DropdownFilterEvent } from 'primeng/dropdown';
import { InputColor } from 'src/app/interfaces/ui.theme';

export type SelectOption = {
  label: string;
  value: string;
};
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
})
export class SelectComponent implements OnInit, OnChanges {
  constructor() {}
  @Input() id!: string;
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() value: any;
  @Input() helperText: string = '';
  @Input() disabled = false;
  @Input() dense: boolean = false;
  @Input() options: SelectOption[] = [];
  @Input() clearable: boolean = false;
  @Input() color!: InputColor;
  @Input() fullWidth: boolean = false;
  @Input() editable: boolean = false;
  @Input() multiSelect: boolean = false;
  @Input() required: boolean = false;
  @Input() filter: boolean = false;
  @Input() defaultValue: string = '';
  @Input() labelPrimary: boolean = false;
  @Input() virtualScroll: boolean = false;
  @Input() virtualScrollItemSize = 1;
  @Input() appendTo: boolean = false;

  @Output() sendChange = new EventEmitter();
  @Output() filterChange = new EventEmitter();

  colorClass = {
    error: 'text-error border-error focus:border-red-500',
    success: 'text-green-500 border-green-200 focus:border-green-500',
    warning: 'text-yellow-500 border-yellow-200 focus:border-yellow-500',
  };

  virtualOptions: ScrollerOptions = {
    delay: 250,
    showLoader: false,
    lazy: true,
  };

  checkAll = false;

  ngOnInit(): void {
    // Ensure value is initialized as an array for MultiSelect
    if (this.multiSelect && !Array.isArray(this.value)) {
      this.value = [];
    }
    this.updateCheckAllState();
  }

  onChange(event: DropdownChangeEvent) {
    this.sendChange.emit(event);
  }

  onFilter(event: DropdownFilterEvent) {
    this.filterChange.emit(event.filter);
  }

  onMultiSelectChange(event: DropdownChangeEvent) {
    this.sendChange.emit(event);
    // Update checkAll state when individual selections change
    this.updateCheckAllState();
  }

  ngOnChanges(): void {
    this.updateCheckAllState();
  }

  updateCheckAllState() {
    if (this.multiSelect && this.options && this.value) {
      // Check if all options are selected
      // this.value is an array of objects with label and value properties
      // Add safety check to ensure this.value is an array
      if (Array.isArray(this.value)) {
        this.checkAll =
          this.options.length > 0 &&
          this.options.every(
            (option) =>
              this.value &&
              this.value.some(
                (selectedItem: any) => selectedItem.value === option.value,
              ),
          );
      } else {
        // If this.value is not an array, treat as no selection
        console.warn('SelectComponent: this.value is not an array:', this.value, 'Type:', typeof this.value);
        this.checkAll = false;
      }
    } else {
      this.checkAll = false;
    }
  }

  onToggleAllClicked(event: Event) {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;

    if (isChecked) {
      this.value = Array.isArray(this.options) ? [...this.options] : [];
    } else {
      // Deselect all options
      this.value = [];
    }

    // Update the checkAll state
    this.checkAll = isChecked;

    // Emit the change event
    this.sendChange.emit({
      originalEvent: event,
      value: this.value,
    });
  }
}
